export default "__VITE_ASSET__CaDOQxQy__"